import { ReactNode } from 'react';
import RestrictedAccess from './RestrictedAccess';

type AcademicPlanFeatureGateProps = {
  featureName: string;
  isRestricted?: boolean;
  children: ReactNode;
};

export default function AcademicPlanFeatureGate({
  featureName,
  isRestricted = false,
  children,
}: AcademicPlanFeatureGateProps) {
  return (
    <RestrictedAccess
      isRestricted={isRestricted}
      strongBlur
      restrictedMessage={
        <>
          <h6>{featureName} is available on Standard, Advanced and Professional plans.</h6>
          <h6>
            Upgrade your plan to unlock this feature.{' '}
            <a href="/academic-plans" style={{ color: '#D02591' }}>
              Upgrade your plan
            </a>
            .
          </h6>
        </>
      }
    >
      {children}
    </RestrictedAccess>
  );
}
